import { Calendar, Home, LayoutDashboard, Settings } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

interface AdminLayoutProps {
  children: React.ReactNode;
}

export function AdminLayout({ children }: AdminLayoutProps) {
  const location = useLocation();

  const navigation = [
    { name: "Reservations", href: "/admin/reservations", icon: LayoutDashboard },
    { name: "Calendar", href: "/admin/calendar", icon: Calendar },
    { name: "Settings", href: "/admin/settings", icon: Settings },
  ];

  const isActive = (href: string) => location.pathname === href;

  return (
    <div className="min-h-screen bg-stone-50 flex">
      {/* Sidebar */}
      <div className="w-64 bg-stone-900 text-white flex flex-col">
        {/* Logo/Brand */}
        <div className="p-6 border-b border-stone-700">
          <Link to="/" className="block">
            <h1 className="font-['Libre_Baskerville'] text-xl font-bold">The Amor</h1>
            <p className="text-xs text-stone-400 mt-1">Admin Dashboard</p>
          </Link>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4">
          <ul className="space-y-2">
            {navigation.map((item) => {
              const Icon = item.icon;
              return (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className={`flex items-center gap-3 px-4 py-3 rounded transition-colors ${
                      isActive(item.href)
                        ? "bg-stone-800 text-white"
                        : "text-stone-300 hover:bg-stone-800 hover:text-white"
                    }`}
                  >
                    <Icon className="size-5" />
                    <span className="font-medium">{item.name}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Back to site */}
        <div className="p-4 border-t border-stone-700">
          <Link
            to="/"
            className="flex items-center gap-3 px-4 py-3 rounded text-stone-300 hover:bg-stone-800 hover:text-white transition-colors"
          >
            <Home className="size-5" />
            <span className="font-medium">Back to Site</span>
          </Link>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col">
        <main className="flex-1 overflow-auto">{children}</main>
      </div>
    </div>
  );
}
